export default __webpack_public_path__ + "static/media/project-bg.778ed73d.png";